import { render } from "./ToolboxRouter.vue?vue&type=template&id=00e3a01e"
import script from "./ToolboxRouter.vue?vue&type=script&lang=js"
export * from "./ToolboxRouter.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/ardia/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__